import { render } from "./FooterNavSubmenu.vue?vue&type=template&id=7284a466&scoped=true&lang=pug"
import script from "./FooterNavSubmenu.vue?vue&type=script&lang=ts"
export * from "./FooterNavSubmenu.vue?vue&type=script&lang=ts"

import "./FooterNavSubmenu.vue?vue&type=style&index=0&id=7284a466&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7284a466"

export default script